import React from 'react';
import { PageSubTitle } from 'Components/Titles';
import { StubLabel } from 'Components/Texts';
import { timestampToDate } from 'Utils/Format';

import './ActiveUserPlan.css';

const ActiveUserPlan = ({ activeBillInfo = {}, nextBillInfo = {} }) => {
  const { planPrice, planName, planFrequency } = activeBillInfo;
  const { nextBillingDateTime, nextBillingAmount } = nextBillInfo;

  const nextBillingDate = timestampToDate(nextBillingDateTime, 2);
  const nextBillingPrice = nextBillingAmount && !Number.isNaN(nextBillingAmount) ? nextBillingAmount.toFixed(2) : '';
  const activePlanPrice = planPrice && planPrice.toFixed(2);
  const nextBillingLabel =
    nextBillingDate && nextBillingPrice ? `$${nextBillingPrice} due on ${nextBillingDate}` : 'unavailable';

  return (
    <section className="sectionFlex billingPlan">
      <div className="flexGrowOne">
        <PageSubTitle text="My Plan" />
      </div>
      <div className="flexGrowThree settingsSectionRight">
        <div className="sectionFlex">
          {planName && <PageSubTitle text={planName} />}
          {activePlanPrice && <div className="activePlanPrice">{`$${activePlanPrice}/${planFrequency}`}</div>}
        </div>
        <div className="sectionFlex">
          <div className="nextBillingInfo">
            <StubLabel text="Next Payment" />
            <div className="nextBillingLabel">{nextBillingLabel}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ActiveUserPlan;
